import { create } from "zustand";
import type { UpgradeReason } from "./proFeatures.js";

/**
 * "Free viewing time is used up — upgrade?" (owner, 2026-09-29).
 *
 * WHY. With the day's free allowance spent, playSource refused before the
 * player showed anything, and every screen that calls it swallows the
 * refusal: pressing a channel did nothing at all, on the guide, Home and
 * Search alike (projector, 2026-09-29). Whatever runs into the limit asks for
 * this instead, and components/UpgradePrompt.tsx answers above every screen.
 */
interface UpgradePromptState {
  /** Which allowance ran out, or which Pro feature was asked for; null while closed. */
  kind: UpgradeReason | null;
  show: (kind: UpgradeReason) => void;
  close: () => void;
}

export const useUpgradePrompt = create<UpgradePromptState>()((set) => ({
  kind: null,
  show: (kind) => set({ kind }),
  close: () => set({ kind: null }),
}));

export function showUpgradePrompt(kind: UpgradeReason): void {
  useUpgradePrompt.getState().show(kind);
}
